export default function LoadingComponent() {
  return (
    <div>
      
    </div>
  );
}
